  <div class="section flex center">
    <app-static-section
      class="box"
      [title]="'StaticPages.AccessDenied.Title' | translate"
      [message]="'StaticPages.AccessDenied.Message' | translate"
      imagePath="./assets/images/permission-denied.svg"
      [showButton]="false"
    ></app-static-section>
  </div>
